<template>
  <div class="sourceContainer">
    ※ 以下敬称略
    <ul class="type">
      <li>
        <span class="unSelectable">【特別協力】</span>
        <ul class="detail">
          <li>
            <div>
              kanko
              <span class="unSelectable">
                (
                <a target="_blank" href="https://twitter.com/kanko_oo">
                  on <span class="icon-twitter"></span> Twitter
                </a>
                )
              </span>
            </div>
            <ul>
              <li>
                <span class="unSelectable">ロゴ作成</span>
              </li>
              <li>
                <span class="unSelectable">Favicon作成</span>
              </li>
              <li>
                <span class="unSelectable">
                  画面デザイン作成（ようこそ画面 - 仕様一覧タブ）
                </span>
              </li>
              <li>
                <span class="unSelectable">
                  ログインに関するユーザフローデザイン
                </span>
              </li>
              <li>
                <span class="unSelectable">
                  画面デザイン作成（ようこそ画面 - ログインタブ）
                </span>
              </li>
              <li>
                <span class="unSelectable">
                  画面デザインアドバイス（プレイヤーボックス画面）
                </span>
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li>
        <span class="unSelectable">【画像関係】</span>
        <ul class="detail illustration">
          <li>
            <div>
              渡空燕丸
              <span class="unSelectable">
                (
                <a target="_blank" href="https://twitter.com/karasuma_kojiro">
                  on
                  <span class="icon-twitter"></span>
                  Twitter
                </a>
                )
              </span>
            </div>
            <ul>
              <li>
                <span class="unSelectable">
                  マスコットキャラクターの創造・作成
                </span>
              </li>
              <li>
                <span class="unSelectable">
                  擬人化キャラクターの創造・作成
                </span>
              </li>
            </ul>
            <span style="font-size: 90%; color: red;">
              キャラクター素材のQuoridorn以外での利用：
              <br />Quoridornの宣伝であることが明確な表記かつ
              <br />非商用の目的の場合は許可いたします。
              <br />悪質な転載・利用を発見した場合は
              <br />直ちにイラストの利用料を請求いたします。
            </span>
            <br />
            <span style="font-size: 90%;">
              キャラクター素材の著作権は
              <br />Quoridorn開発者HillTopが所有しています。
            </span>
          </li>
          <li>
            <div>
              <span class="unSelectable">デフォルトマップ背景</span>
            </div>
            <div>
              <span class="unSelectable">サイト名：</span>
              TEDDY-PLAZA
              <span class="unSelectable">
                (
                <a target="_blank" href="http://teddy-plaza.sakura.ne.jp">
                  LINK
                </a>
                )
              </span>
            </div>
            <div>
              <span class="unSelectable">作品名：</span>
              「麦畑と村」
              <span class="unSelectable">
                (
                <a
                  target="_blank"
                  href="http://teddy-plaza.sakura.ne.jp/?cat=105"
                >
                  LINK
                </a>
                )
              </span>
            </div>
          </li>
          <li>
            <div>
              <span class="unSelectable">入力中アイコン</span>
            </div>
            <div>
              <span class="unSelectable">サイト名：</span>
              みんなの知識 ちょっと便利帳
              <span class="unSelectable">
                (
                <a target="_blank" href="https://www.benricho.org/">
                  LINK
                </a>
                )
              </span>
            </div>
            <div>
              <span class="unSelectable">作品名：</span>
              「不明」
              <span class="unSelectable">
                (
                <a
                  target="_blank"
                  href="https://www.benricho.org/loading_images/transparent01.html"
                >
                  LINK
                </a>
                )
              </span>
            </div>
          </li>
          <!--
          <li>
            <div><span class="unSelectable">favicon作成</span></div>
            <div><span class="unSelectable">サイト名：</span>Free logo Maker - Supalogo.com<span class="unSelectable"> (<a target="_blank" href="https://supalogo.com/#">LINK</a>)</span></div>
            <div>
              <span class="unSelectable">設定：</span>
              <ul>
                <li>
                  <span class="unSelectable">text: </span>Q
                </li>
                <li>
                  <span class="unSelectable">SPECIFY THE EFFECT TO APPLY: </span>Gradient colors #1e90ff #00ffff
                </li>
                <li>
                  <span class="unSelectable">SPECIFY A FONT FOR YOUR LOGO: </span>Facon(new)
                </li>
                <li>
                  <span class="unSelectable">size: </span>21px
                </li>
              </ul>
            </div>
          </li>
          -->
        </ul>
      </li>
      <li>
        <span class="unSelectable">【カード】</span>
        <ul class="detail">
          <li>
            <div>
              <span class="unSelectable">
                トランプ (タロットカード小アルカナ)
              </span>
            </div>
            <div>
              <span class="unSelectable">サイト名：</span>
              Wikipedia Commons
              <span class="unSelectable">
                (
                <a target="_blank" href="https://commons.wikimedia.org">
                  LINK
                </a>
                )
              </span>
            </div>
            <div>
              <span class="unSelectable">参照一覧：</span>
              <ul>
                <li>
                  English pattern playing cards deck
                  <span class="unSelectable">
                    (
                    <a
                      target="_blank"
                      href="https://commons.wikimedia.org/wiki/File:English_pattern_playing_cards_deck.svg"
                    >
                      LINK
                    </a>
                    )
                  </span>
                </li>
                <li>
                  Joker black 02
                  <span class="unSelectable">
                    (
                    <a
                      target="_blank"
                      href="https://commons.wikimedia.org/wiki/File:Joker_black_02.svg"
                    >
                      LINK
                    </a>
                    )
                  </span>
                </li>
                <li>
                  Joker red 02
                  <span class="unSelectable">
                    (
                    <a
                      target="_blank"
                      href="https://commons.wikimedia.org/wiki/File:Joker_red_02.svg"
                    >
                      LINK
                    </a>
                    )
                  </span>
                </li>
                <li>
                  Carta Francese retro Rosso
                  <span class="unSelectable">
                    (
                    <a
                      target="_blank"
                      href="https://commons.wikimedia.org/wiki/File:Carta_Francese_retro_Rosso.jpg"
                    >
                      LINK
                    </a>
                    )
                  </span>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <div>
              <span class="unSelectable">花札</span>
            </div>
            <div>
              <span class="unSelectable">サイト名：</span>
              pixiv
              <span class="unSelectable">
                (
                <a target="_blank" href="https://www.pixiv.net/">
                  LINK
                </a>
                )
              </span>
            </div>
            <div>
              <span class="unSelectable">作者：</span>
              メタボルタ
            </div>
            <div>
              <span class="unSelectable">作品名：</span>
              「花札＠どどんとふ」
              <span class="unSelectable">
                (
                <a
                  target="_blank"
                  href="https://www.pixiv.net/member_illust.php?mode=medium&illust_id=52572048"
                >
                  LINK1
                </a>
                /
                <a
                  target="_blank"
                  href="https://www.pixiv.net/member_illust.php?mode=medium&illust_id=52619352"
                >
                  LINK2
                </a>
                )
              </span>
            </div>
          </li>
          <li>
            <div>
              <span class="unSelectable">タロットカード 大アルカナ</span>
            </div>
            <div>
              <span class="unSelectable">サイト名：</span>
              flickr
              <span class="unSelectable">
                (
                <a target="_blank" href="https://www.flickr.com">
                  LINK
                </a>
                )
              </span>
            </div>
            <div><span class="unSelectable">作者：</span>Sigo Paolini</div>
            <div>
              <span class="unSelectable">作品名：</span>
              「Napo Tarot」
              <span class="unSelectable">
                (
                <a
                  target="_blank"
                  href="https://www.flickr.com/photos/thegreathorsecigar/sets/72157634257174286"
                >
                  LINK
                </a>
                )
              </span>
            </div>
          </li>
        </ul>
      </li>
      <li>
        <span class="unSelectable">【音楽】</span>
        <ul class="detail">
          <li>
            <div>
              <span class="unSelectable">効果音</span>
            </div>
            <div>
              <span class="unSelectable">サイト名：</span>
              効果音ラボ
              <span class="unSelectable">
                (
                <a target="_blank" href="https://soundeffect-lab.info/">
                  LINK
                </a>
                )
              </span>
            </div>
            <div>
              <span class="unSelectable">作品名：</span>
              「出題1」など
              <span class="unSelectable">
                (
                <a
                  target="_blank"
                  href="https://soundeffect-lab.info/sound/anime/"
                >
                  LINK
                </a>
                )
              </span>
            </div>
          </li>
          <li>
            <div>
              <span class="unSelectable">BGM</span>
            </div>
            <div>
              <span class="unSelectable">サイト名：</span>
              H/MIX GALLARY Free Music Download Site
              <span class="unSelectable">
                (
                <a target="_blank" href="http://www.hmix.net/">
                  LINK
                </a>
                )
              </span>
            </div>
            <div>
              <span class="unSelectable">作品名：</span>
              「馬車道」など
              <span class="unSelectable">
                (
                <a
                  target="_blank"
                  href="http://www.hmix.net/music_gallery/feeling/happy.htm"
                >
                  LINK
                </a>
                )
              </span>
            </div>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {};
</script>

<style scoped src="./source.css"></style>
